import React from 'react'
import LightboxGallery from '../lightbox-gallery'
import StyledImage from '../styled-image'

export default function Gallery({ props, index }) {
  const { images, imageBorderColor, overlayImage } = props
  const settingsOverrides = images ? {
    slidesToShow: 3,
    slidesToScroll: 1,
    className: `slick-arrows-centered slick-cropped-5/4 `,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  } : null
  return (
    <section className={`my-12`}>
      <div className={`container relative pb-12`}>
        <style>
          {imageBorderColor ? `
          .slick-slide img {
            border: 10px solid ${imageBorderColor};
          `: ""}
        </style>
        {images ?
          <div className={`pt-5 max-w-[calc(100vw_-_4rem)] sm:max-w-full relative`}>
            <LightboxGallery props={{ images }} isCarousel={true} settingsOverrides={settingsOverrides} />
            {overlayImage ?
              <div className={`absolute -top-2 md:top-1/4 left-1/5 md:left-[29%] flex items-center justify-center`}>
                <StyledImage
                  image={overlayImage}
                  objectFit="contain"
                  objectPosition={"center"}
                  className="w-16 lg:w-24" />
              </div> : null}
          </div>
          : null}
      </div>
    </section>
  )
}